export default "__VITE_ASSET__BuiThjgN__"